/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PublishInputs */

const en_publish = /** @type {(inputs: PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish`)
};

const fr_publish = /** @type {(inputs: PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publier`)
};

const de_publish = /** @type {(inputs: PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichen`)
};

const it_publish = /** @type {(inputs: PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pubblicare`)
};

const ru_publish = /** @type {(inputs: PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Публиковать`)
};

const es_publish = /** @type {(inputs: PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicar`)
};

const zh_cn2_publish = /** @type {(inputs: PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布`)
};

const ja_publish = /** @type {(inputs: PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開`)
};

const hi_publish = /** @type {(inputs: PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकाशित करना`)
};

const pt_pt2_publish = /** @type {(inputs: PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicar`)
};

/**
* | output |
* | --- |
* | "Publish" |
*
* @param {PublishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const publish = /** @type {((inputs?: PublishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PublishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_publish(inputs)
	if (locale === "de") return de_publish(inputs)
	if (locale === "it") return it_publish(inputs)
	if (locale === "ru") return ru_publish(inputs)
	if (locale === "es") return es_publish(inputs)
	if (locale === "zh-CN") return zh_cn2_publish(inputs)
	if (locale === "ja") return ja_publish(inputs)
	if (locale === "hi") return hi_publish(inputs)
	if (locale === "pt-PT") return pt_pt2_publish(inputs)
	return en_publish(inputs)
});